/**
*
* TwoStepControl
*
*/

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from 'components/interaction/IconButton/index.jsx';
import IntlString from '../../media/IntlString/index.jsx';
import EditDeleteControl from '../EditDeleteControl/index.jsx';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  & > :first-child {
    flex-grow: 1;
  }
  .btn {
    margin-left: 10px;
    margin-top: -3px;
    margin-bottom: -3px;
  }
  .btn-link {
    margin-left: 0;
    opacity: 0.5;
    height: 32px;
  }
  .ss-settings {
    font-size: 150%;
  }
`;

function getLabel(value, options) {
  if (!options) {
    return value;
  }
  const found = options.find((opt) => opt.value === value);
  return found ? <IntlString message={found.label} /> : value;
}

function TwoStepControl(props) {
  const [show, setShow] = useState(false);
  const { Control, onChange, onDelete, confirmDeleteText, ...rest } = props;
  const { value, options } = props;
  const [newValue, setValue] = useState(value);
  function handleSave() {
    onChange(newValue);
    setShow(false);
  }
  function handleCancel() {
    setValue(value);
    setShow(false);
  }
  if (show) {
    return (
      <Wrapper>
        <Control {...rest} value={newValue} onChange={setValue} autoFocus />
        <IconButton size="sm" variant="success" icon="ss-checkmark fs-3" onClick={handleSave} />
        <IconButton size="sm" variant="light" icon="ss-delete fs-3" onClick={handleCancel} />
      </Wrapper>
    );
  }
  if (onDelete) {
    return (
      <Wrapper>
        <span>{getLabel(newValue, options)}</span>
        <EditDeleteControl
          onEdit={() => setShow(true)}
          onDelete={onDelete}
          confirmDeleteText={confirmDeleteText}
          icon="ss-settings"
          className="test-class"
        />
      </Wrapper>
    );
  }
  return (
    <Wrapper>
      <span>{getLabel(newValue, options)}</span>
      <IconButton variant="link" icon="ss-draw fs-3" className="pe-1" onClick={() => setShow(true)} />
    </Wrapper>
  );
}

TwoStepControl.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  confirmDeleteText: PropTypes.object,
  Control: PropTypes.any,
};

export default TwoStepControl;
